import { setGeo } from './helpers';
import { TJsonQuery } from './types';

export function clearGeo(jsonQuery: TJsonQuery): () => TJsonQuery {
  return () => setGeo()(jsonQuery)([]);
}
